import { ChronosphereDataQueryDefinition, PrometheusQueryReducer } from './schema';

export interface QueryStats {
  /**
   * The time it took to execute the query.
   */
  responseTimeMs?: number;
}

/**
 * A generic query definition interface that can be extended to support more than just TimeSeriesQuery
 */
export type QueryDefinition = TimeSeriesQueryDefinition;

export interface QuerySpec<PluginDefinition> {
  // Optional unique ID for the query
  id?: string;
  plugin: PluginDefinition;
  disabled?: boolean;
  alias?: string;
}

export type TimeSeriesQueryDefinition = {
  kind: 'DataQuery';
  spec: QuerySpec<ChronosphereDataQueryDefinition>;
};

export const PROMETHEUS_REDUCER_OPTIONS: Readonly<
  Record<PrometheusQueryReducer, { label: string; description: string }>
> = {
  First: {
    label: 'First',
    description: 'First value',
  },
  Last: {
    label: 'Last',
    description: 'Last value',
  },
  FirstNumber: {
    label: 'First *',
    description: 'First numeric value',
  },
  LastNumber: {
    label: 'Last *',
    description: 'Last numeric value',
  },
  Avg: {
    label: 'Avg',
    description: 'Average value excluding nulls',
  },
  Sum: {
    label: 'Total',
    description: 'The total of all values',
  },
  Min: {
    label: 'Min',
    description: 'Minimum value',
  },
  Max: {
    label: 'Max',
    description: 'Maximum value',
  },
} as const;

const EMPTY_QUERIES: QueryDefinition[] = [];

/** Check if a query has actual content (non-empty query string) */
function hasQueryContent(q: QueryDefinition): boolean {
  const query = q.spec.plugin.spec?.query;
  return typeof query === 'string' && query.trim().length > 0;
}

/** Filter queries to only those with actual content.*/
export function getQueriesWithContent(queries: QueryDefinition[] | undefined): QueryDefinition[] {
  if (!queries || queries.length === 0) return EMPTY_QUERIES;
  return queries.filter(hasQueryContent);
}
